import { useSelector } from 'react-redux'

import { Recipe } from '@features/recipe-preferences/src/types/recipe'

import { getMenuRecipes, getStoreRecipes } from '../Steps/RecipePreference/selectors'

export const useRecipesList = () => {
  const menuRecipes = useSelector(getMenuRecipes)
  const storeRecipesRaw = useSelector(getStoreRecipes)
  const storeRecipes = storeRecipesRaw ? storeRecipesRaw.toJS() : {}

  const recipesArray = menuRecipes ? menuRecipes.toArray().slice(0, 18) : []

  return recipesArray.reduce((acc, recipeId) => {
    const recipe = storeRecipes[recipeId]
    if (recipe) {
      acc[recipeId] = recipe
    }

    return acc
  }, {} as Record<string, Recipe>)
}
